import { combineReducers } from 'redux';
import serverMeta, { NAME as serverMetaKey } from './reducers/server';
import status, { NAME as statusKey } from './reducers/status';

export default combineReducers({
    [statusKey]: status,
    [serverMetaKey]: serverMeta,
});
